// Setting style rules to `null` will prevent them from being rendered
// This allows for standard styling using CSS without the need to use !important

export default {
  // Container
  control: {
    minHeight: null,
    width: null
  },

  // Mentioned Name Overlay
  highlighter: {
    lineHeight: null,
    border: '1px solid transparent',
    minHeight: null,
    padding: null,
    color: null,
    width: null,
    pointerEvents: 'none'
  },

  // <textarea> tag
  input: {
    backgroundColor: null,
    boxSizing: null,
    display: null,
    fontFamily: null,
    fontSize: null,
    height: null,
    resize: null,
    width: null
  },

  // Mentioned Popover
  suggestions: {
    backgroundColor: null,
    left: 0,
    marginTop: null,
    minWidth: null,
    position: 'absolute',
    right: 0,
    top: null,
    width: null,
    zIndex: 50,
    // <ul> element
    list: {
      listStyleType: null,
      margin: null,
      padding: null
    },
    // <li> element
    item: {
      cursor: null,

      '&focused': {
        backgroundColor: '#e6e6e6'
      }
    }
  }
};
